import { Dispatch, SetStateAction, useState } from 'react';
import { useIntl } from 'react-intl';
import { handleError } from '../../../components/errors/errorHandling';
import { addSuccessToast } from '../../../components/errors/toast/ToastUtils';
import { FormModel } from '../../../models/form/form';
import { updateForm as updateFormService, updateFormResponseModel } from '../../../services/form/FormService';

interface Values {
  isLoading: boolean;
  updateForm: (form: FormModel, avatarFile: File | null) => Promise<updateFormResponseModel | null>;
  setOrganizationId: Dispatch<SetStateAction<string>>;
}

const useUpdateForm = (organizationId: string): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [id, setOrganizationId] = useState<string>(organizationId);
  const intl = useIntl();

  const updateForm = async (form: FormModel, avatarFile: File | null) => {
    try {
      setIsLoading(true);
      const { data } = await updateFormService(id, form, avatarFile);
      setIsLoading(false);
      addSuccessToast({ message: intl.formatMessage({ id: 'success.saved' }) });
      return data;
    } catch (error) {
      handleError(error);
      setIsLoading(false);
    }
    return null;
  };
  return { updateForm, isLoading, setOrganizationId };
};

export default useUpdateForm;
